import { MDBIcon } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Header from "../components/header/Header";
import code from "../components/images/Code.svg";
import pdf from "../components/images/pdf.svg";
import { getStreamsProductName } from "../apiclients/CommonUtils";



function LandingPage() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const streamsProductName = getStreamsProductName();
    function redirectTo(e, tpage, stateparams) {
        try {
            if (e) e.preventDefault();
            navigate(tpage, {
                state: stateparams,
            });
        } catch (e) { }
    }


    return (
        <React.Fragment>
            <>
                <div className="MobileNotSupport">
                    <div className="position-fixed top-0 w-100 nav-Header ">
                        <a className="navbar-brand p-3" href="/home">
                            <i className="logo"></i>
                        </a>
                    </div>
                </div>

                <header>
                    <Header active="21" />
                </header>
                <main className="page-content toggled homepage mt-5 pt-4 streamshelp" id="page-content">
                    <div className="container-fluid">
                        <div className="card">
                            <h5 className="card-header fw-600">{t("Helpdocs")}</h5>
                            <div className="card-body p-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="quicklinks streamshelp">
                                            <div className="">
                                                <ul className="p-0 mb-0">
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/html/saas/StreamsWebHelp/index.htm">
                                                            <img src={code} />
                                                            {streamsProductName} Help
                                                        </a>
                                                    </li>
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/html/ConnectHelp_v6/index.htm" >
                                                            <img src={code} />
                                                            Connect Help
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/saas/QuickstartUsers.pdf" >
                                                            <img src={pdf} />
                                                            {streamsProductName} Quickstart Guide
                                                        </a>
                                                    </li>
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/PolycomQuickStartGuide.pdf" >
                                                            <img src={pdf} />
                                                            Polycom Quickstart Guide
                                                        </a>
                                                    </li>
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/VoicemailInstructionsChart.pdf"  >
                                                            <img src={pdf} />
                                                            Voicemail Instructions
                                                        </a>
                                                    </li>
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/YealinkQuickStartGuide.pdf"  >
                                                            <img src={pdf} />
                                                            Yealink Quickstart Guide
                                                        </a>
                                                    </li>
                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/Grandstream_Quick_Start_Guide.pdf"  >
                                                            <img src={pdf} />
                                                            Grandstream Quickstart Guide
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/html/OpenCTIHelp/OpenCTI_Help_Lightning.html"  >
                                                            <img src={code} />
                                                            Salesforce Lightning CTI Help
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/html/ZohoIntegration/Integration_with_Zoho.htm"   >
                                                            <img src={code} />
                                                            Zoho Integration Help
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/pdfs/RecordingaGreetingviatheTelephonyGreetingManager.pdf"  >
                                                            <img src={pdf} />
                                                            Greeting Manager
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="https://settings.streams.us/docs/html/Zendesk_Integration_with_Streams/Streams_Integration_with_Zendesk.htm"   >
                                                            <img src={code} />
                                                            Zendesk Integration Help
                                                        </a>
                                                    </li>

                                                    <li className="list-group">
                                                        <a className="link" target="_blank"
                                                            href="http://www.panterranetworks.com/agreements/eusa_agreement.html"  >
                                                            <MDBIcon far icon="handshake" className="pe-2" />
                                                            End User Agreement
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        </React.Fragment>
    );
}
export default LandingPage;
